module.exports = __webpack_public_path__ + "static/img/2s-design-b2.0e000ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/2s-design-b2.jpg
// module id = BDu5
// module chunks = 0